import styles from './LoginModal.module.scss';
import ValidateButton from '../UI/ValidateButton';
import Close from '@src/assets/Close.png';
import { Formik, Form } from 'formik';
import Input from '../UI/Input';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { loginCheck } from '@src/api/Auth';
import { Toaster, toast } from 'react-hot-toast';

type LoginModalProps = {
    onClose: (value: boolean) => void;
}

export default function LoginModal({ onClose }: LoginModalProps) {
    const [hidePasswords, setHidePasswords] = useState<boolean>(true);

    const { mutate, isPending } = useMutation({
        mutationFn: ({ login, password }: { login: string; password: string }) => loginCheck({login, password}),
        onSuccess: async () => {
            onClose(true);
        },
        onError: (error: any) => {
            toast.dismiss();
            if (error.response?.status === 401) {
                toast.error("Le couple login / mot de passe est incorrect");
            } else {
                toast.error('Une erreur est survenue, veuillez recommencer.', { position: 'top-center' })
            }
        }
    });

    return (
        <div className={styles.modalContainer}>
            <div className={styles.modal}>
                <div className={styles.close} onClick={() => onClose(true)}>
                    <img src={Close} alt="Close" width={14} height={14} />
                </div>
                <p className={styles.title}>Connexion</p>
                <p className={styles.description}>Merci de vous connecter pour poursuivre votre inscription.</p>
                <Formik
                    initialValues={{ email: '', password: '' }}
                    onSubmit={values => {
                        mutate({ login: values.email, password: values.password });
                    }}
                >
                    {({ handleChange, handleSubmit, values, errors, isValid, touched, handleBlur }) => {
                        const handleKeyDown = (event: React.KeyboardEvent) => {
                            if (event.key === 'Enter' && isValid && values.email && values.password) {
                                event.preventDefault();
                                handleSubmit();
                            }
                        };
                        return(
                            <Form className={styles.inputContainer} id="loginForm" onKeyDown={handleKeyDown}>
                                <Input
                                    title="Adresse email/login"
                                    width="100%"
                                    value={values.email}
                                    onChange={handleChange('email')}
                                    placeholder="Email/login"
                                    type="text"
                                    clearInput={() => handleChange('email')('')}
                                    hasError={(touched.email && errors.email) as boolean}
                                    onBlur={handleBlur('email')}
                                />
                                <Input
                                    title="Mot de passe"
                                    width="100%"
                                    value={values.password}
                                    onChange={handleChange('password')}
                                    placeholder="Mot de passe"
                                    type={hidePasswords ? "password" : "text"}
                                    isPassword
                                    hidePassword={hidePasswords}
                                    setHidePassword={(value: boolean) => setHidePasswords(value)}
                                    clearInput={() => handleChange('password')('')}
                                    hasError={(touched.password && errors.password) as boolean}
                                    onBlur={handleBlur('password')}
                                />
                                <ValidateButton title="Valider" onClick={handleSubmit} disabled={!isValid || !values.email || !values.password} onLoading={isPending} />
                            </Form>
                        )
                    }}
                </Formik>
            </div>
            <Toaster/>
        </div>
    );
}
